<template>
  <div
    id="shoppercheckmanagement"
    v-if="globals.isAccessAllowed('LoopOp_ShopperSurveyInstances_ReadAll')"
  >
    <!-- ******************* -->
    <!-- *     Toolbar     * -->
    <!-- ******************* -->
    <!-- This is the panel on top of the page where buttons, pagination and searchbar are displayed -->
    <div class="panel panel-default" id="shoppercheckmanagement-top-panel">
      <div class="panel-body">
        <div class="col-md-12">
          <!-- Add buttons here  -->
          <button
            class="btn btn-raised btn-top-bar"
            :disabled="!refreshEnabled"
            @click="getShopperCheckList()"
          >
            <i class="material-icons md-36">refresh</i>
            <br />
            {{ lang.SM4000 }}
          </button>
          <!-- TODO: Export -->
          <!-- <button
            class="btn btn-raised btn-top-bar"
            @click="openShopperCheckExportConfirmationDialog()"
          >
            <i class="material-icons md-36">file_download</i>
            <br>
            {{lang.SM4004}}
          </button>-->
          <button
            class="btn btn-raised btn-top-bar"
            :disabled="selectedChecks.length === 0"
            @click="showCheckPaymentModal = true"
            v-if="
              feature.isEnabled('settlement') &&
              globals.isPaymentsReadingAllowed
            "
          >
            <i class="material-icons md-36">attach_money</i>
            <br />
            {{ lang.SM4021 }}
          </button>
          <router-link
            tag="button"
            to="/shoppermanagement"
            class="btn btn-raised btn-top-bar"
          >
            <i class="material-icons md-36">exit_to_app</i>
            <br />
            {{ lang.SM4001 }}
          </router-link>
        </div>
      </div>

      <div class="panel-body">
        <div class="col-lg-5">
          <!-- Searchbar - triggered by enter key -->
          <div class="form-group searchbar">
            <input
              type="search"
              class="form-control"
              id="inputSearch"
              :placeholder="lang.SM4002"
              v-model="searchString"
              @keyup.enter="(selectedPage = 1), doFiltering()"
            />
          </div>
        </div>
        <div class="col-lg-2">
          <div class="well user-info-box">
            <span
              >{{ shopperData.LastName }}, {{ shopperData.FirstName }} ({{
                shopperData.Username
              }})</span
            >
          </div>
        </div>
        <div class="col-lg-5 nopadding">
          <!-- Pagination -->
          <ul class="pagination-fonts pagination btn-group">
            <li>
              <!-- Dropdown: Select the number of elements per page -->
              <a
                role="button"
                class="dropdown-toggle"
                data-toggle="dropdown"
                id="elementsPerPageDropdown"
              >
                <i class="material-icons md-18">view_headline</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="elementsPerPageDropdown"
                :delay="globals.tooltipDelay"
                >{{ lang.SM4023 }}</b-tooltip
              >
              <ul class="dropdown-menu">
                <!-- Add dropdown entries here -->
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 20 }"
                    role="button"
                    @click="updatePaging(1, 20)"
                    >20</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 50 }"
                    role="button"
                    @click="updatePaging(1, 50)"
                    >50</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 100 }"
                    role="button"
                    @click="updatePaging(1, 100)"
                    >100</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 200 }"
                    role="button"
                    @click="updatePaging(1, 200)"
                    >200</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 500 }"
                    role="button"
                    @click="updatePaging(1, 500)"
                    >500</a
                  >
                </li>
              </ul>
            </li>

            <!-- Jump to first page -->
            <li
              v-bind:class="{
                disabled: !filteredShopperChecklist.length || selectedPage == 1,
              }"
              @click="updatePaging(1, 0)"
            >
              <a role="button" id="firstPageButton">
                <i class="material-icons md-18">first_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="firstPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.SM4024 }}</b-tooltip
              >
            </li>
            <!-- ... -->
            <li v-if="numberOfPages() > 7 && selectedPage > 4" class="disabled">
              <a role="button">...</a>
            </li>
            <!-- Pagenumbers -->
            <li
              v-for="pageNumber in getVisiblePages()"
              :key="pageNumber"
              v-bind:class="{ active: selectedPage == pageNumber }"
              @click="updatePaging(pageNumber, 0)"
            >
              <a role="button">{{ pageNumber }}</a>
            </li>
            <!-- ... -->
            <li
              v-if="numberOfPages() > 7 && selectedPage < numberOfPages() - 3"
              class="disabled"
            >
              <a role="button">...</a>
            </li>
            <!-- Jump to last page -->
            <li
              v-bind:class="{
                disabled:
                  !filteredShopperChecklist.length ||
                  selectedPage == numberOfPages(),
              }"
              @click="updatePaging(numberOfPages(), 0)"
            >
              <a role="button" id="lastPageButton">
                <i class="material-icons md-18">last_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="lastPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.SM4025 }}</b-tooltip
              >
            </li>
            <li class="disabled">
              <a role="button" id="shopperChecksTotalElementsCounter">{{
                filteredShopperChecklist.length
              }}</a>
              <b-tooltip
                ref="tooltip"
                target="shopperChecksTotalElementsCounter"
                :delay="globals.tooltipDelay"
                >{{ lang.SM4026 }}</b-tooltip
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="panel panel-default">
      <div class="panel-body">
        <table class="table table-striped table-hover main-table">
          <thead>
            <tr>
              <!-- Add table headers here -->
              <!-- The table sort is triggered by click on the header -->
              <th style="width: 5%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('SurveyInstanceId')"
                >
                  {{ lang.SM4003 }}
                  <span
                    v-if="showSortArrow('SurveyInstanceId', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('SurveyInstanceId', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 12%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('ProjectName')"
                >
                  {{ lang.SM4005 }}
                  <span
                    v-if="showSortArrow('ProjectName', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('ProjectName', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 12%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('WaveName')"
                >
                  {{ lang.SM4006 }}
                  <span
                    v-if="showSortArrow('WaveName', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('WaveName', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 12%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('ScenarioName')"
                >
                  {{ lang.SM4007 }}
                  <span
                    v-if="showSortArrow('ScenarioName', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('ScenarioName', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th
                style="width: 9%"
                class="text-center"
                v-if="
                  !feature.isAudiTarget || !feature.isEnabled('audi_importers')
                "
              >
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('ClientName')"
                >
                  {{ lang.SM4008 }}
                  <span
                    v-if="showSortArrow('ClientName', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('ClientName', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 9%" class="text-center" v-else>
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('ImporterName')"
                >
                  {{ lang.SM4022 }}
                  <span
                    v-if="showSortArrow('ImporterName', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('ImporterName', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 9%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('LocationName')"
                >
                  {{ lang.SM4009 }}
                  <span
                    v-if="showSortArrow('LocationName', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('LocationName', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 12%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('LocationAddress')"
                >
                  {{ lang.SM4011 }}
                  <span
                    v-if="showSortArrow('LocationAddress', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('LocationAddress', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 4%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('LocationCountry')"
                >
                  {{ lang.SM4012 }}
                  <span
                    v-if="showSortArrow('LocationCountry', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('LocationCountry', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 4%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('SurveyInstanceStatusId')"
                >
                  {{ lang.SM4010 }}
                  <span
                    v-if="showSortArrow('SurveyInstanceStatusId', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('SurveyInstanceStatusId', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 7%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('SettlementState')"
                >
                  {{ lang.SM4013 }}
                  <span
                    v-if="showSortArrow('SettlementState', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('SettlementState', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 7%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('SettlementNumber')"
                >
                  {{ lang.SM4014 }}
                  <span
                    v-if="showSortArrow('SettlementNumber', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('SettlementNumber', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 7%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('SettlementDate')"
                >
                  {{ lang.SM4015 }}
                  <span
                    v-if="showSortArrow('SettlementDate', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('SettlementDate', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
            </tr>
            <tr class="table-filters">
              <th class="nopadding" style="width: 5%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SM4016"
                    v-model="filterStrings.SurveyInstanceId"
                    @keyup.enter="(selectedPage = 1), doFiltering()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 12%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SM4016"
                    v-model="filterStrings.ProjectName"
                    @keyup.enter="(selectedPage = 1), doFiltering()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 12%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SM4016"
                    v-model="filterStrings.WaveName"
                    @keyup.enter="(selectedPage = 1), doFiltering()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 12%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SM4016"
                    v-model="filterStrings.ScenarioName"
                    @keyup.enter="(selectedPage = 1), doFiltering()"
                  />
                </div>
              </th>
              <th
                class="nopadding"
                style="width: 9%"
                v-if="
                  !feature.isAudiTarget || !feature.isEnabled('audi_importers')
                "
              >
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SM4016"
                    v-model="filterStrings.ClientName"
                    @keyup.enter="(selectedPage = 1), doFiltering()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 9%" v-else>
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SM4016"
                    v-model="filterStrings.ImporterName"
                    @keyup.enter="(selectedPage = 1), doFiltering()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 9%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SM4016"
                    v-model="filterStrings.LocationName"
                    @keyup.enter="(selectedPage = 1), doFiltering()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 12%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SM4016"
                    v-model="filterStrings.LocationAddress"
                    @keyup.enter="(selectedPage = 1), doFiltering()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 4%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SM4016"
                    v-model="filterStrings.LocationCountry"
                    @keyup.enter="(selectedPage = 1), doFiltering()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 4%">
                <div
                  class="form-group filterbar"
                  id="checkStatusFilterContainer"
                >
                  <select2
                    class="form-control nopadding"
                    v-model="filterStrings.SurveyInstanceStatusId"
                    :allowClear="true"
                    :placeholder="lang.SM4016"
                    @change="(selectedPage = 1), doFiltering()"
                  >
                    <option></option>
                    <option
                      v-for="status in checkStates"
                      :key="status"
                      :value="status"
                    >
                      {{ status }}
                    </option>
                  </select2>
                </div>
              </th>
              <th class="nopadding" style="width: 7%">
                <div
                  class="form-group filterbar"
                  id="settlementStatusFilterContainer"
                  v-if="Object.keys(settlementStatusses).length > 0"
                >
                  <Select2
                    class="form-control nopadding"
                    v-model="filterStrings.SettlementState"
                    :allowClear="true"
                    :placeholder="lang.SM4016"
                    @change="(selectedPage = 1), doFiltering()"
                  >
                    <option></option>
                    <option
                      v-for="(name, guid) of settlementStatusses"
                      :key="guid"
                      :value="name"
                    >
                      {{ name }}
                    </option>
                  </Select2>
                </div>
              </th>
              <th class="nopadding" style="width: 7%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SM4016"
                    v-model="filterStrings.SettlementNumber"
                    @keyup.enter="(selectedPage = 1), doFiltering()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 7%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SM4016"
                    v-model="filterStrings.SettlementDate"
                    @keyup.enter="(selectedPage = 1), doFiltering()"
                  />
                </div>
              </th>
            </tr>
          </thead>
          <tbody class="main-table-scrollbar">
            <tr
              role="button"
              v-for="check in shopperChecksOnCurrentPage"
              :key="check.SurveyInstanceId"
              @click="selectChecks(check.SurveyInstanceGuid, $event)"
              :class="{ info: isCheckSelected(check.SurveyInstanceGuid) }"
            >
              <td style="width: 5%">{{ check.SurveyInstanceId }}</td>
              <td style="width: 12%">{{ check.ProjectName }}</td>
              <td style="width: 12%">{{ check.WaveName }}</td>
              <td style="width: 12%">{{ check.ScenarioName }}</td>
              <td
                style="width: 9%"
                v-if="
                  !feature.isAudiTarget || !feature.isEnabled('audi_importers')
                "
              >
                {{ check.ClientName }}
              </td>
              <td style="width: 9%" v-else>{{ check.ImporterName }}</td>
              <td style="width: 9%">{{ check.LocationName }}</td>
              <td style="width: 12%">{{ check.LocationAddress }}</td>
              <td style="width: 4%">{{ check.LocationCountry }}</td>
              <td style="width: 4%">{{ check.SurveyInstanceStatusId }}</td>
              <td style="width: 7%">{{ check.SettlementState }}</td>
              <td style="width: 7%">{{ check.SettlementNumber }}</td>
              <td style="width: 7%">{{ check.SettlementDate }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <CheckPaymentModal
      :showModal="showCheckPaymentModal"
      :surveyInstanceGuids="selectedChecks"
      @modalClosed="(showCheckPaymentModal = false), getShopperCheckList()"
    ></CheckPaymentModal>
  </div>
</template>

<script>
import CheckPaymentModal from "../CheckManagement/CheckPaymentModal";
import Select2 from "../Tools/Select2";

export default {
  name: "ShopperCheckManagement",
  components: {
    CheckPaymentModal,
    Select2,
  },
  props: ["selectedShopperGuid"],
  data() {
    return {
      searchString: "",
      refreshEnabled: false,
      showCheckPaymentModal: false,
      shopperCheckList: [],
      filteredShopperChecklist: [],
      shopperChecksOnCurrentPage: [],
      selectedPage: 1,
      pageSize: 20,
      selectedCheckGuid: "",
      settlementStatusses: {},
      shopperData: {},
      selectedShopper: {},
      selectedChecks: [],
      checkStates: [100, 110, 120],
      lastSelectedCheck: -1,
      currentSort: { key: "SurveyInstanceStatusId", asc: true },
      filterStrings: {
        SurveyInstanceId: "",
        ProjectName: "",
        WaveName: "",
        ScenarioName: "",
        ClientName: "",
        ImporterName: "",
        LocationName: "",
        LocationAddress: "",
        LocationCountry: "",
        SurveyInstanceStatusId: "",
        SettlementState: "",
        SettlementNumber: "",
        SettlementDate: "",
      },
      lang: {
        SM4000: "Refresh",
        SM4001: "Close",
        SM4002: "Search...",
        SM4003: "Check ID",
        SM4004: "Export",
        SM4005: "Project",
        SM4006: "Wave",
        SM4007: "Scenario",
        SM4008: "Client",
        SM4009: "Location Name",
        SM4010: "Check State",
        SM4011: "Location Address",
        SM4012: "Location Country",
        SM4013: "Payoff State",
        SM4014: "Payoff Number",
        SM4015: "Payoff Date",
        SM4016: "Filter",
        SM4017: "Shopper Checks Export",
        SM4018: "Download",
        SM4019: "Cancel",
        SM4020: "Export selected checks from shopper",
        SM4021: "Payments",
        SM4022: "Importer",
        SM4023: "Items per page",
        SM4024: "First page",
        SM4025: "Last page",
        SM4026: "Total checks count",
      },
    };
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this, this.setTableHeight);
      this.settlementStatusses = {};
      this.filterStrings.SettlementState = "";
      this.globals.getSettlementStatusses((data) => {
        this.settlementStatusses = data;
        this.getShopperCheckList();
      });
    },
  },
  mounted() {
    this.readComponentSettingsFromStore();
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this, this.setTableHeight);
      this.globals.getSettlementStatusses((data) => {
        this.settlementStatusses = data;
      });
    }
    this.getShopperInformation();
    this.getShopperCheckList();

    // Sets the new table height after the window got resized
    $(window).on("resize", this.setTableHeight).resize();

    if (!this.globals.currentUserInfo)
      this.globals.$once("currentUserInfoReceived", this.setTableHeight);

    // Register global events
    this.globals.$off("ShopperCheckManagementYesConfirmation");
    this.globals.$on("ShopperCheckManagementYesConfirmation", () => {
      this.exportSelectedShopperChecks();
    });
  },
  destroyed() {
    $(window).off("resize", this.setTableHeight);
  },
  destroyed() {
    this.writeComponentSettingsToStore();
  },
  methods: {
    readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (
        !this.feature.isAudiTarget ||
        !this.feature.isEnabled("audi_importers")
      ) {
        let storedClient = this.$store.getters["sharedFilters/client"];
        if (storedClient.ClientName) {
          this.filterStrings.ClientName = this.globals.removeWildcardsFromString(
            storedClient.ClientName
          );
        } else this.filterStrings.ClientName = "";
      } else {
        let storedImporter = this.$store.getters["sharedFilters/importer"];
        if (storedImporter.ImporterName) {
          this.filterStrings.ImporterName = this.globals.removeWildcardsFromString(
            storedImporter.ImporterName
          );
        } else this.filterStrings.ImporterName = "";
      }

      let storedProject = this.$store.getters["sharedFilters/project"];
      if (storedProject.ProjectName) {
        this.filterStrings.ProjectName = this.globals.removeWildcardsFromString(
          storedProject.ProjectName
        );
      } else this.filterStrings.ProjectName = "";
    },
    writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (
        !this.feature.isAudiTarget ||
        !this.feature.isEnabled("audi_importers")
      ) {
        let storedClient = this.$store.getters["sharedFilters/client"];
        if (
          this.globals.removeWildcardsFromString(storedClient.ClientName) !==
          this.filterStrings.ClientName
        ) {
          this.$store.commit("sharedFilters/client", {
            ClientName: this.globals.addWildcardsToString(
              this.filterStrings.ClientName
            ),
          });
        }
      } else {
        let storedImporter = this.$store.getters["sharedFilters/importer"];
        if (
          this.globals.removeWildcardsFromString(
            storedImporter.ImporterName
          ) !== this.filterStrings.ImporterName
        ) {
          this.$store.commit("sharedFilters/importer", {
            ImporterName: this.globals.addWildcardsToString(
              this.filterStrings.ImporterName
            ),
          });
        }
      }

      let storedProject = this.$store.getters["sharedFilters/project"];
      if (
        this.globals.removeWildcardsFromString(storedProject.ProjectName) !==
        this.filterStrings.ProjectName
      ) {
        this.$store.commit("sharedFilters/project", {
          ProjectName: this.globals.addWildcardsToString(
            this.filterStrings.ProjectName
          ),
        });
      }
    },
    getShopperCheckList() {
      let queryString = `api/Shopper/${this.selectedShopperGuid}/SurveyInstances`;
      this.refreshEnabled = false;

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.shopperCheckList = [];
          if (!_.isEmpty(data)) this.shopperCheckList = data;
          for (let check of this.shopperCheckList) {
            if (check.SettlementDate)
              check.SettlementDate = this.globals.getLocalizedDateFromIsoTimestamp(
                check.SettlementDate
              );
          }
          this.setSettlementsStates();
          this.doFiltering();
        },
        error: () => {
          console.error("Error on GET in getShopperCheckList()");
          this.globals.showErrorSnackbar("Check data request failed");
        },
        complete: () => {
          this.refreshEnabled = true;
        },
      });
    },
    getShopperInformation() {
      let queryString = `api/Shopper/${this.selectedShopperGuid}`;

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.shopperData = data;
        },
        error: () => {
          console.error("Error on GET in getShopperInformation()");
          this.globals.showErrorSnackbar("Shopper data request failed");
        },
      });
    },
    setSettlementsStates() {
      if (_.isEmpty(this.settlementStatusses)) {
        // Wait for request
        setTimeout(() => {
          this.setSettlementsStates();
        }, 500);
        return;
      }

      this.shopperCheckList.forEach((check) => {
        if (check.SurveyInstanceStatusId < 120) check.SettlementState = "-";
        else
          check.SettlementState = this.settlementStatusses[
            check.SettlementStatusGuid
          ];
      });
      this.$forceUpdate();
    },
    setTableHeight() {
      this.$nextTick(() => {
        let height = $(window).height();
        height -=
          $("#shoppercheckmanagement-top-panel").height() +
          $("#app-navbar").height() +
          $("#shoppercheckmanagement .main-table > thead").height() +
          47;
        $("#shoppercheckmanagement .main-table-scrollbar").css(
          "max-height",
          height
        );
      });
    },
    doFiltering() {
      // Reset filtering when search string is empty
      if (this.searchString)
        this.filteredShopperChecklist = this.shopperCheckList;

      let words = this.searchString.split(" ");
      let keys = [
        "SurveyInstanceId",
        "ProjectName",
        "WaveName",
        "ScenarioName",
        "ClientName",
        "ImporterName",
        "LocationName",
        "LocationAddress",
        "LocationCountry",
        "SurveyInstanceStatusId",
        "SettlementState",
        "SettlementNumber",
        "SettlementDate",
      ];

      const surveyFilter = (survey) => {
        let containsSearch = false;
        words.forEach((word) => {
          keys.forEach((key) => {
            if (
              survey[key] &&
              survey[key].toString().toLowerCase().indexOf(word.toLowerCase()) >
                -1
            ) {
              containsSearch = true;
              return;
            }
          });
        });
        if (!containsSearch) return false;
        keys.forEach((key) => {
          if (!containsSearch) return;
          if (
            (!survey[key] && this.filterStrings[key]) ||
            (survey[key] &&
              survey[key]
                .toString()
                .toLowerCase()
                .indexOf(this.filterStrings[key].toLowerCase()) < 0)
          ) {
            containsSearch = false;
            return;
          }
        });
        return containsSearch;
      };
      this.filteredShopperChecklist = !_.isEmpty(this.shopperCheckList)
        ? this.shopperCheckList.filter(surveyFilter)
        : [];
      this.currentSort.asc = !this.currentSort.asc;
      this.orderTableByColumn(this.currentSort.key);
    },
    showSortArrow(key, asc) {
      return this.currentSort.key === key && this.currentSort.asc === asc;
    },
    orderTableByColumn(orderProp) {
      if (!orderProp && !this.currentSort.key) return;
      if (orderProp) {
        this.currentSort.key === orderProp
          ? (this.currentSort.asc = !this.currentSort.asc)
          : (this.currentSort = { asc: true, key: orderProp });
      }
      if (orderProp === "SurveyInstanceStatusId") {
        this.orderCheckStateColumn();
      } else {
        const sortFunction = (check) => {
          if (typeof check[this.currentSort.key] === "string") {
            return check[this.currentSort.key].toLowerCase();
          }
          return check[this.currentSort.key];
        };
        this.filteredShopperChecklist = _.orderBy(
          this.filteredShopperChecklist,
          [sortFunction],
          [this.currentSort.asc ? "asc" : "desc", "asc"]
        );
      }
      this.loadCurrentPageOfShopperChecks();
      this.$nextTick(() => {
        this.setTableHeight();
      });
    },
    orderCheckStateColumn() {
      let checkStateSortOrder = [110, 100, 120];
      let ordering = {};
      checkStateSortOrder.forEach(
        (element, index) => (ordering[element] = index)
      );
      this.currentSort.asc
        ? this.filteredShopperChecklist.sort(
            (a, b) =>
              ordering[a.SurveyInstanceStatusId] -
              ordering[b.SurveyInstanceStatusId]
          )
        : this.filteredShopperChecklist.sort(
            (a, b) =>
              ordering[b.SurveyInstanceStatusId] -
              ordering[a.SurveyInstanceStatusId]
          );
      this.loadCurrentPageOfShopperChecks();
    },
    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages() {
      if (this.numberOfPages() <= 7) {
        return _.range(1, this.numberOfPages() + 1);
      } else if (this.numberOfPages() > 7 && this.selectedPage <= 4) {
        return _.range(1, 7);
      } else if (
        this.numberOfPages() > 7 &&
        this.selectedPage >= this.numberOfPages() - 3
      ) {
        return _.range(this.numberOfPages() - 5, this.numberOfPages() + 1);
      } else {
        return _.range(this.selectedPage - 2, this.selectedPage + 3);
      }
    },
    updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber;
      if (pageSize != 0) this.pageSize = pageSize;
      this.loadCurrentPageOfShopperChecks();
    },
    // Returns the count of pages depending on the selected pagesize and the length of the client data list
    numberOfPages() {
      if (this.pageSize == -1) return 1;
      if (this.filteredShopperChecklist.length % this.pageSize == 0)
        return this.filteredShopperChecklist.length / this.pageSize;
      else
        return (
          parseInt(this.filteredShopperChecklist.length / this.pageSize) + 1
        );
    },
    loadCurrentPageOfShopperChecks() {
      if (this.pageSize == -1)
        this.shopperChecksOnCurrentPage = this.filteredShopperChecklist;
      else {
        // Display all data, no pages
        this.shopperChecksOnCurrentPage = [];
        var startIndex = (this.selectedPage - 1) * this.pageSize;
        for (var i = startIndex; i < startIndex + this.pageSize; i++) {
          if (this.filteredShopperChecklist[i] != null)
            this.shopperChecksOnCurrentPage[
              i - startIndex
            ] = this.filteredShopperChecklist[i];
        }
      }
    },
    openShopperCheckExportConfirmationDialog() {
      this.globals.$emit(
        "openGlobalConfirmationDialog",
        this.getExportShopperData()
      );
    },
    getExportShopperData() {
      return {
        initiator: "ShopperCheckManagement",
        confirmationTitle: this.lang.SM4017,
        yesButtonText: this.lang.SM4018,
        noButtonText: this.lang.SM4019,
        htmlText: `<p>${this.lang.SM4020}</p>`,
      };
    },
    // TODO: implement export api
    exportSelectedShopperChecks() {
      console.log("export");
    },
    selectChecks(checkGuid, e) {
      if (!e) return;

      if (e.ctrlKey && !e.shiftKey) {
        let idx = _.indexOf(this.selectedChecks, checkGuid);
        if (idx > -1) {
          _.pullAt(this.selectedChecks, idx);
          this.lastSelectedCheck = -1;
        } else {
          this.selectedChecks.push(checkGuid);
          this.lastSelectedCheck = checkGuid;
        }
      } else if (!e.ctrlKey && e.shiftKey) {
        document.getSelection().removeAllRanges();
        if (this.lastSelectedCheck < 0) return;

        let idx1 = _.findIndex(this.shopperChecksOnCurrentPage, (c) => {
          return c.SurveyInstanceGuid == this.lastSelectedCheck;
        });
        let idx2 = _.findIndex(this.shopperChecksOnCurrentPage, (c) => {
          return c.SurveyInstanceGuid == checkGuid;
        });

        if (idx1 > idx2) [idx2, idx1] = [idx1, idx2];

        for (let i = idx1; i <= idx2; i++) {
          if (
            !this.isCheckSelected(
              this.shopperChecksOnCurrentPage[i].SurveyInstanceGuid
            )
          )
            this.selectedChecks.push(
              this.shopperChecksOnCurrentPage[i].SurveyInstanceGuid
            );
        }
      } else {
        this.selectedChecks = [checkGuid];
        this.lastSelectedCheck = checkGuid;
      }
      this.$forceUpdate();
    },
    isCheckSelected(checkGuid) {
      return _.indexOf(this.selectedChecks, checkGuid) > -1;
    },
  },
};
</script>

<style>
#checkStatusFilterContainer > .select2.select2-container {
  margin: -1px 0 1px 0;
}
#checkStatusFilterContainer .select2-selection {
  background: transparent;
}
#checkStatusFilterContainer .select2-selection .select2-selection__rendered {
  text-align: center;
}
#settlementStatusFilterContainer > .select2.select2-container {
  margin: -1px 0 1px 0;
}
#settlementStatusFilterContainer .select2-selection {
  background: transparent;
}
#settlementStatusFilterContainer
  .select2-selection
  .select2-selection__rendered {
  text-align: center;
}
</style>

<style scoped>
.filterbar > input {
  max-height: 35px;
}

.user-info-box {
  height: 42px;
  width: 100%;
  margin: 8px 0;
  padding: 0;
  display: table;
}
.user-info-box > span {
  display: table-cell;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// ShopperCheckManagement.vue?6d101e9b